/**
 * Created by joerg on 20.05.17.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Utils from '../utils/Utils';
import InputComponent from '../components/InputComponent';
import OutPutComponent from '../components/OutPutComponent';
import InputModel from '../models/InputModel'
import DropDown from '../components/DropDown'



@observer
export default class KurzergebnisHor extends React.Component {

    _onChange(e,entry){
        console.log('ch',e.target.value,entry)
        entry.value = e.target.value;
    }
    componentDidUpdate(){
        setTimeout(()=>{requestAnimationFrame(this._calcwidths);},200);

    }
    componentDidMount(){
        this.componentDidUpdate();
    }
    _calcwidths(){
        console.log('calcwidth')





    }

    render (){
        const {baseDataStore,brespaAnalyseStore,halbfertigAnalyseStore,ortbetonAnalyseStore} = this.props;
      //  const self = this;
        var z = 200;
        var toofat = baseDataStore.totalDicke.value - brespaAnalyseStore.totalDicke.value > 8;

        var brespaout = <div className="col-md-4">
            <div className="well">

                <h5>BRESPA Decke</h5>
                <div className="form-group zup" >
                    <OutPutComponent outputModel={brespaAnalyseStore.totalValueBrespa} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                </div>

                <div className="form-group zup" >
                    <OutPutComponent outputModel={brespaAnalyseStore.totalDicke} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                </div>
            </div>
        </div>;

        var hfout = <div className="col-md-4 ">
            <div className="well"><h5>Halbfertigteildecke</h5>
                <div className="form-group zup" >
                    <OutPutComponent outputModel={halbfertigAnalyseStore.totalValue} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                </div>
                <div className="form-group zup" >
                    <OutPutComponent outputModel={baseDataStore.totalDicke} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                </div></div>
        </div>;

        var obout = <div className="col-md-4 ">
            <div className="well"><h5>Ortbetondecke</h5>
                <div className="form-group zup" >
                    <OutPutComponent outputModel={ortbetonAnalyseStore.totalValue} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                </div>
                <div className="form-group zup" >
                    <OutPutComponent outputModel={baseDataStore.totalDicke} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                </div></div>
        </div>;
        if(toofat){

            brespaout = <div className="col-md-4">
                <div className="well">

                    <h5><strong>BRESPA®</strong>-Decke</h5>
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={brespaAnalyseStore.totalValueBrespa} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={brespaAnalyseStore.totalKostenStuetzung} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={brespaAnalyseStore.totalValueBrespaStuetzung} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                </div>
            </div>;

            hfout = <div className="col-md-4 ">
                <div className="well"><h5>Halbfertigteildecke</h5>
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={halbfertigAnalyseStore.totalValueBrespa} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                        <OutPutComponent outputModel={halbfertigAnalyseStore.totalKostenStuetzung} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={halbfertigAnalyseStore.totalValueBrespaStuetzung} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                </div>
            </div>;
            obout = <div className="col-md-4 ">
                <div className="well"><h5>Ortbetondecke</h5>
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={ortbetonAnalyseStore.totalValueBrespa} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                        <OutPutComponent outputModel={ortbetonAnalyseStore.totalKostenStuetzung} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                    <div className="form-group zup" >
                        <OutPutComponent outputModel={ortbetonAnalyseStore.totalValueBrespaStuetzung} inputClasses={['size-input-height']} setRightAddon={true} setleftaddon={true}/>
                    </div>
                </div>
            </div>;
        }


        return <div id="kurzergebnis" >
            <h4>Ergebnisse</h4>
            <hr/>
            <div className="row">
                {brespaout}
                {hfout}
                {obout}
            </div>

        </div>;
    }

}

KurzergebnisHor.propTypes = {
    baseDataStore: PropTypes.object.isRequired,
    brespaAnalyseStore:PropTypes.object.isRequired,
    halbfertigAnalyseStore:PropTypes.object.isRequired,
    ortbetonAnalyseStore: PropTypes.object.isRequired
}


// WEBPACK FOOTER //
// ./src/components/KurzergebnisHor.js